import React, { useState } from 'react';
import { Menu, Icon, Input } from 'semantic-ui-react';
import CardMCSummaryOverview from './CardMCSummaryOverview';
import CardMCSummaryProduct from './CardMCSummaryProduct';
import CardMCSummaryPerformance from './CardMCSummaryPerformance';
import CardMC2Panel from './CardMC2Panel';

type CardMCRevenueServicePerformanceProps = {
  controller: any;
  runSequence: any;
  MeChartSequence: any;
  productTypeOptions: any;
  packageTypeOptions: any;
  searchedItemListWithKey?: Record<string, any>;
}

const CardMCRevenueServicePerformance = (props: CardMCRevenueServicePerformanceProps) => {
  const [activeItem, setActiveItem] = useState('overview');
  const [searchQuery, setSearchQuery] = useState('');

  const menuItems = [
    { name: 'overview', label: 'สรุปยอดขายสินค้า / บริการ (Overview)' },
    { name: 'rank5', label: 'สรุปยอดขายสินค้า / บริการ (Product)' },
    { name: 'performance', label: 'สรุป Performance ผู้ให้บริการ' },
  ];

  const handleItemClick = (e: any, { name }: any) => setActiveItem(name);

  const filteredMenuItems = menuItems.filter(item =>
    item.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const leftPanelContent = (
    <>
      <div className="search-container">
        <Input
          icon='search'
          placeholder='Search reports...'
          fluid
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      <Menu fluid vertical tabular className="nav-menu">
        {filteredMenuItems.map((item) => (
          <Menu.Item
            key={item.name}
            name={item.name}
            active={activeItem === item.name}
            onClick={handleItemClick}

          >
            <div className="item-content">
              <span>{item.label}</span>
              {activeItem === item.name && <Icon name='chevron right' className="icon" />}
            </div>
          </Menu.Item>
        ))}
      </Menu>
    </>
  );

  return (
    <div id="card-mc-revenue-service-performance">
      <CardMC2Panel
        leftPanel={
          <div className="left-panel-container">
            {leftPanelContent}
          </div>
        }
        rightPanel={
          <div className="right-panel-container">
            {activeItem === 'overview' &&
              <CardMCSummaryOverview
                controller={props.controller}
                runSequence={props.runSequence}
                MeChartSequence={props.MeChartSequence}
              />}
            {activeItem === 'rank5' &&
              <CardMCSummaryProduct
                controller={props.controller}
                runSequence={props.runSequence}
                MeChartSequence={props.MeChartSequence}
                productTypeOptions={props.productTypeOptions}
                packageTypeOptions={props.packageTypeOptions}
                searchedItemListWithKey={props.searchedItemListWithKey}
              />}
            {activeItem === 'performance' &&
              <CardMCSummaryPerformance
                controller={props.controller}
                runSequence={props.runSequence}
                MeChartSequence={props.MeChartSequence}
                searchedItemListWithKey={props.searchedItemListWithKey}
              />}
          </div>
        }
      />
    </div>
  );
};

export default CardMCRevenueServicePerformance;
